//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  name: "steps",
  props: ["outSteps"],
  data() {
    return {};
  },
  methods: {
    ...mapActions([])
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
